module.exports = JSON.parse('{"name":"nutrisense","displayName":"nutrisense"}')